<template>
  <div class="b-capsule-content">
    <b-row class="justify-content-center">
      <b-col
        cols="3"
        xs="3"
        sm="3"
        md="2"
        lg="2"
        class="layer p-2"
        v-for="layer in sortBySequence"
        :key="layer.id"
      >
        <Layer :layer="layer" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layer from "@/components/capsule/CapsuleLayerOld";

export default {
  components: {
    Layer,
  },

  props: {
    outfit: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sortBySequence() {
      return _.sortBy(this.outfit.layers, "sequence");
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/stitchedOutfits/OutfitContent.vue